import { render, staticRenderFns } from "./TextMessagesList.vue?vue&type=template&id=3e72bfa9"
import script from "./TextMessagesList.vue?vue&type=script&lang=ts"
export * from "./TextMessagesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports